import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import { omit } from 'lodash-es';
import SelectTree from './select-tree.vue';
import DetailDialog from './detail-dialog.vue';
var month = {
  start: dayjs().startOf('month').format('YYYY-MM-DD'),
  end: dayjs().endOf('month').format('YYYY-MM-DD')
};
function createQueryModel() {
  return {
    // 开始时间
    b_time: month.start,
    // 结束时间
    e_time: month.end,
    // 选中菜单的key
    menu_key: '',
    // 操作人
    operator_staff_id: '',
    // 被操作人
    operator_obj: '',
    // 当前页面
    page: 1,
    // 每页展示的条数
    page_size: 20
    // 操作人列排序 asc 或者 desc
    // operator_sort: 'desc',
    // 时间列排序 asc 或者 desc
    // time_sort: 'desc'
  };
}

export default {
  components: {
    SelectTree: SelectTree,
    DetailDialog: DetailDialog
  },
  data: function data() {
    return {
      // 时间范围值
      rangValues: [month.start, month.end],
      menuList: [],
      fieldNames: {
        id: 'id',
        label: 'name',
        children: 'children',
        key: 'key'
      },
      queryModel: createQueryModel(),
      // table loading
      loading: false,
      // export btn loading
      exportLoading: false,
      // table data source
      operateRecordList: [],
      totalPage: 0,
      menuKeys: []
    };
  },
  created: function created() {
    this.getMenuList();
    this.getOperateRecordList();
  },
  methods: {
    searchList: function searchList() {
      this.queryModel.page = 1;
      this.getOperateRecordList();
    },
    // 获取操作记录列表
    getOperateRecordList: function getOperateRecordList() {
      var _this = this;
      if (!this.queryModel.b_time) {
        this.$message.warning(this.$t('i18n.b8b9253375794a6a85b913a1cd588a55'));
        return;
      }
      this.loading = true;
      this.$http({
        url: '/web/operate_record/list',
        method: 'GET',
        params: this.queryModel
      }).then(function (res) {
        res.data.items.forEach(function (item) {
          item.menuKey = "".concat(item.menu_key, "-").concat(item.sub_menu_key);
        });
        _this.operateRecordList = res.data.items;
        _this.totalPage = res.data.totalNum;
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 获取菜单列表
    getMenuList: function getMenuList() {
      var _this2 = this;
      this.$http({
        url: '/web/resource/list'
      }).then(function (res) {
        _this2.menuList = res.data.filter(function (item) {
          return item.key !== 'menu.tool';
        });
        _this2.menuList.forEach(function (item) {
          if (item.key === 'menu.staff' || item.key === 'menu.work') {
            _this2.menuKeys.push(item.key);
            if (item.children) {
              item.children.forEach(function (child) {
                _this2.menuKeys.push(child.key);
              });
            }
          }
        });
      });
    },
    // 选择时间回调事件
    handleDatePickerChange: function handleDatePickerChange(v) {
      if (!v) {
        this.queryModel.b_time = '';
        this.queryModel.e_time = '';
        return;
      }
      var _v = _slicedToArray(v, 2),
        b = _v[0],
        e = _v[1];
      this.queryModel.b_time = b;
      this.queryModel.e_time = e;
    },
    // 排序事件
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      var sortKeys = {
        created_time: 'created_time',
        operator_staff_name: 'staff_name'
      };
      var key = sortKeys[prop];
      var sortModel = {
        sort: key,
        dir: order
      };
      this.queryModel = _objectSpread(_objectSpread({}, this.queryModel), sortModel);
      this.getOperateRecordList();
    },
    handleExport: function handleExport() {
      var _this3 = this;
      var data = omit(this.queryModel, ['page', 'page_size']);
      this.exportLoading = true;
      this.$http({
        url: '/web/operate_record/exportLog',
        data: data
      }).then(function (res) {
        var object_url = res.data.down_load_excel.object_url;
        window.location.href = object_url;
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    handleView: function handleView(scope) {
      this.$refs.detailDialog.init(scope.row.id);
    },
    /**
     * @description: 点击下载
     * @param {*} row
     * @return {*}
     */
    doDownloadFn: function doDownloadFn(row) {
      var _row$attachment;
      var url = row === null || row === void 0 || (_row$attachment = row.attachment) === null || _row$attachment === void 0 ? void 0 : _row$attachment.url;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  }
};